import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import {
  Form,
  InputNumber,
  Button,
  Col,
  Row,
  Layout,
  Breadcrumb,
  Skeleton,
  message,
} from "antd";
import { getHRMSettings, updateHRMSettings } from "../../../actions/hrmSettingsAction";

const { Content } = Layout;

const HRMSettings = ({ getHRMSettings, updateHRMSettings, hrmSettings }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getHRMSettings().then(() => {
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (hrmSettings) {
      form.setFieldsValue(hrmSettings);
    }
  }, [hrmSettings, form]);

  const onFinish = (values) => {
    updateHRMSettings(values).then(() => {
      message.success("HRM Settings updated successfully");
    });
  };

  const renderContent = () => {
    if (loading) {
      return <Skeleton active />;
    }

    return (
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={hrmSettings}
        style={{ maxWidth: "600px" }}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="overnight_multiplier"
              label="Overnight Multiplier"
              rules={[{ required: true, message: "Please enter the multiplier" }]}
              extra="This multiplier is used to calculate night shift hourly payment (Default: 1.5)"
            >
              <InputNumber
                min={0}
                step={0.1}
                style={{ width: "100%" }}
                placeholder="Enter multiplier (e.g. 1.5)"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Settings
          </Button>
        </Form.Item>
      </Form>
    );
  };

  return (
    <Layout className="window-frame">
      <Sidebar />
      <Layout className="site-layout">
        <Navbar />
        <Content className="main-frame-content">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>HRM</Breadcrumb.Item>
            <Breadcrumb.Item>Settings</Breadcrumb.Item>
          </Breadcrumb>
          <div className="site-layout-background main-frame">
           
            {renderContent()}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    hrmSettings: state.hrmSettings.hrmSettings,
  };
};

export default connect(mapStateToProps, {
  getHRMSettings,
  updateHRMSettings,
})(HRMSettings);
